import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import YoutubeSearchedForIcon from '@material-ui/icons/YoutubeSearchedFor'
import searchPageContext from '../../FiltersComponent/context/context'
import { formatDate, clearSelectedProperties, getErrorAlertDuration } from '../../Utility/Utility'
import { viewList } from '../../Utility/Utility'
import { pollMessageStatus } from '../../../PropertyList/Utility/GetMessageStatus/GetMessageStatus'
import updatePropertyList from '../../../PropertyList/Utility/UpdatePropertyList/UpdatePropertyList'

const UpdateExistingList = props => {
    const [updateClicked, setUpdateClicked] = useState(false)
    // const { keycloak } = useKeycloak()
    let [selectedListSearch, setSelectedListSearch] = useState(undefined)

    let { savedLists, fetchSavedLists, searchResult, setSearchResult, setalertProps, setShowAlert,
        searchCriteria, setSelectedMenu, openModalWindow } = useContext(searchPageContext)
    const [selectedPropertyCount, setSelectedPropertyCount] = useState(0)

    useEffect(() => {
        if (updateClicked) {
            handleUpdate()
        }
    }, [updateClicked])

    useEffect(() => {
        setSelectedPropertyCount(searchResult.property.filter(row => row.checked).length)
    }, [searchResult])

    const getUpdatePayload = () => {
        try {
            // let selectedProps = [...selectedListSearch.compsList]
            let selectedProps = []

            let maxRank = selectedListSearch.compsList && selectedListSearch.compsList.length > 0 ? Math.max(...selectedListSearch.compsList.map(o => o.rank)) : 0;
            let count = maxRank ? maxRank + 1 : 1

            let fieldsToUpdate = []
            let omniViewPropertyListId = selectedListSearch.omniViewPropertyListId
            let polarisPropertySearchCriteriaId = selectedListSearch.polarisPropertySearchCriteriaId

            searchResult.property.forEach((prop) => {
                if (prop.checked) {
                    count++
                    selectedProps.push(
                        {
                            "omniViewPropertyId": prop.omniViewPropertyId,
                            "isSubjectProperty": searchCriteria.subjectProperty && (prop.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId),
                            "rank": count,
                            "action": "add"
                        })
                }
            })

            fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: omniViewPropertyListId })
            fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: polarisPropertySearchCriteriaId })
            fieldsToUpdate.push({ key: 'compsList', value: selectedProps })
            fieldsToUpdate.push({ key: 'compType', value: selectedListSearch.compType })

            return fieldsToUpdate
        }
        catch (e) {
            console.log('Error in get-UpdatePayload :: ', e)
        }
    }

    const removeDuplicates = () => {
        const selectedPropsList = selectedListSearch.compsList.map((pro) => {
            return pro.omniViewPropertyId
        })

        searchResult.property.forEach((prop) => {
            if (prop.checked) {
                if (selectedPropsList.indexOf(prop.omniViewPropertyId) !== -1) {
                    prop.checked = false
                }
            }
        })

    }

    const createAlert = (polarisPropertySearchCriteriaId) => {

        return (
            <>
                <span>
                    List Updated. <span><a className="btn btn-link underline" onClick={() => { viewList(polarisPropertySearchCriteriaId, '', setSelectedMenu) }}><strong>View</strong></a></span>
                </span>
            </>
        )
    }

    const onUpdate = async (message, type) => {

        try {

            if (type === 'success') {
                await fetchSavedLists()
            }

            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleUpdate = async () => {
        try {

            if (selectedListSearch) {
                removeDuplicates()
                setSelectedListSearch(undefined)
                // const response = await saveSavedSearch(payload)
                let fieldsToUpdate = getUpdatePayload()
                openModalWindow(true)
                props.handleClose()
                const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
                const response = await updatePropertyListObj.update()

                setUpdateClicked(false)

                if (response && response.status === 200) {
                    clearSelectedProperties(searchResult, setSearchResult)
                    pollMessageStatus(response.data.messageId, onUpdate, createAlert, '', 'Something went wrong !!')
                } else {
                    const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                    setalertProps({ message: errorMessage, type: 'error' })
                    setShowAlert(true)
                }
                // setUpdateClicked(false)

                // if (response && response.status === 200) {
                //     // fetchSavedSearch()
                //     fetchSavedSearch(!refreshSavedSearch)
                //     clearSelectedProperties(searchResult, setSearchResult)

                //     setalertProps({ message: createAlert(omniViewPropertyListId, polarisPropertySearchCriteriaId), type: 'success' })
                //     setShowAlert(true)
                //     props.handleClose()
                // } else {
                //     setalertProps({ message: 'Something went wrong!! ', type: 'error' })
                //     setShowAlert(true)
                // }

            }
            // else {
            //     setalertProps({ message: 'Property already exists in the list ', type: 'error' })
            //     setShowAlert(true)
            //     props.handleClose()
            // }
        } catch (e) {
            console.log('Error ::: ', e)
        }
    }

    const getCheckedStatus = value => {
        let returnVal = false

        if (selectedListSearch && selectedListSearch.polarisPropertySearchCriteriaId === value.polarisPropertySearchCriteriaId && selectedListSearch.omniViewPropertyListId === value.omniViewPropertyListId) {
            returnVal = true
        }

        return returnVal
    }

    const getOwnerName = list => {
        let name = ''

        if (list.polarisUserName) {
            name = list.polarisUserName
        }

        if (!name && list.omniViewUserName) {
            name = list.omniViewUserName
        }

        return name
    }

    return (
        <>
            <div className='h-max-80 flex flex-col py-4 gap-4'>
                <div className="flex flex-row border-b-1 border-base px-4 pb-2">
                    <span className="pb-4">
                        <YoutubeSearchedForIcon></YoutubeSearchedForIcon>
                    </span>
                    <span className="px-2"> Update existing list </span>
                </div>
                <div className="border-b-1 border-base flex flex-col overflow-y-auto popover-w disable-scrollbars">
                    {savedLists.map(value => (
                        <>
                            {value.isCart &&
                                <div onClick={() => { setSelectedListSearch(value) }} key={value.name} className="flex flex-row justify-between items-center border-b-1 border-base px-3 py-3 cursor-default hover:bg-gray-15">
                                    <div className="px-6 flex flex-col"  >
                                        <div className="text-base">
                                            {value.name}
                                        </div>
                                        <div className="text-muted text-1">
                                            Last Modified : {formatDate(value.lastModifiedDate, 'mmDDYYYY')}
                                        </div>
                                        <div className="text-muted text-1">
                                            Created By : {getOwnerName(value)}
                                        </div>
                                    </div>
                                    <div className="pr-4">
                                        <input checked={getCheckedStatus(value)} type="radio" name="radio-saved-search" />
                                    </div>
                                </div>
                            }
                        </>
                    ))}
                </div>
                {savedLists.length === 0 &&
                    <div className="p-6 border-b-1 border-base">
                        You can Save a List.
                        <br />Come back here to load your saved lists.
                    </div>
                }
                <div>                            
                    <small className="text-danger">{selectedPropertyCount > 199 ? '* You cannot add more than 199 properties to list' : ''}</small>
                </div>
                <div className="p-4">
                    <div className="flex justify-end space-x-4 mt-auto">
                        <div>
                            <button data-testid="button-cancel" onClick={props.handleClose} className="btn btn-sm" type="button">Close</button>
                        </div>

                        <div>
                            {updateClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Updating</span>
                                </button>
                                :
                                <button data-testid="button-update" onClick={() => { setUpdateClicked(true) }} className={`btn btn-sm btn-primary ${selectedListSearch && selectedPropertyCount < 200 ? '' : 'c-disabled'}`} > Update </button>
                            }

                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateExistingList

UpdateExistingList.propTypes = {
    handleClose: PropTypes.any,
    view: PropTypes.string,
}
